import React from 'react';
import { Redirect, generatePath } from 'react-router';

import { Designer } from 'src/shared/constants/FeatureFlag';
import { useTreatment } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

export const ThreeDFusionRedirect = ({
  jobId: jobIdProp,
}: {
  jobId?: string;
}) => {
  const isThreeDFusionEnabled =
    useTreatment(Designer.ENABLED_3D_FUSION) === 'on';
  const jobId = Number(jobIdProp);
  const redirect = isThreeDFusionEnabled && !!jobIdProp && !isNaN(jobId);

  const redirectTo = generatePath(
    Route.HOMEOWNER_APP_INTERSTITIAL_THREE_D_FUSION.path,
    { jobId },
  );

  return redirect ? <Redirect to={redirectTo} /> : null;
};
